// extracted by mini-css-extract-plugin
module.exports = {"button":"PreviewMessage_button___Vg3Y"};